import { API } from '../src/Constant'

export const ENDPOINTS = {
    USER_DETAILS: API + "/admin/grid",
    ACCOUNT_CLOSURE: API + "/admin/account-closure",
    HOME_VALUATION: API + "/admin/home-valuation-update",
    PROMO_CODES: API + "/admin/promocode-records",
    GIFTCARD_DASBOARD: API + "/admin/gift-card-dashboard",
    EQUIFAX_ADDRESS: API + "/admin/equifax-address",
    READ_CREDIT_REPORT: API + "/admin/read-credit-report",
    WITHDRAW_USER_AMOUNT: API + "/admin/withdraw-user-amount",
    TRANSFER_AMOUNT_TO_USER_WALLET: API + "/admin/transfer-amount-to-user-wallet",
    REFUND_AMOUNT_TO_USER_ACCOUNT: API + "/admin/refund-amount-to-user-account",
    USER_REMORTGAGE: API + "/admin/user-remortgage",
    USER_ACTIVITY: API + "/admin/user-account-activity",
    USER_INFLIGHT_DETAILS: API + "/admin/user-inflight-details",
    USER_SESSION_INFO: API + "/admin/user-session-info",
    USER_LIVE_EWALLET_HISTORY_FETCH: API + "/admin/user_live_ewallet_history_fetch",
    TRANSFER_REWARD_AMOUNT: API + "/admin/transfer-reward-amount",
    REDIS_CACHE_CLEANER: API + "/admin/redis-cache-clean",
    ADD_PROMOCODE: API + "/admin/add-promocode",
    ADD_REFERRAL: API + "/admin/add-referral",
    UPDATE_PAY_TO_LENDER: API + "/admin/update-pay-to-lender",
    UPDATE_PENDING_TASK: API + "/admin/update-pending-task",
    UPDATE_USER_PENDING_ACTION: API + "/admin/update-user-pending-action",
    VERIFICATION_LINK: API  + "/admin/verification-link",
    PPS_PAYEE: API + "/admin/pps-payee",
    DELETE_USER: API + "/admin/delete-user",
    MANAGE_USER: API + "/admin/manage-user",
    PN_NOTIFIER: API + "/admin/pn-notifier",
    MASTER_TO_USER_EWALLET_FAILURE: API + "/admin/master-to-user-ewallet-failure",
    AML_VERIFICTION_PPS: API + "/admin/aml-verification-pps",
    TOGGLE_DIRECT_DEBIT: API + "/admin/toggle-direct-debit",
    UPDATE_GIFT_CARD_BLACKLIST: API + "/admin/update-gift-card-blacklist",
    REMORTGAGE_LETTER: API + "/admin/remortgage-letter",
    GENERATE_BROKER_REPORT: API + "/admin/generate-broker-report",
    ADD_AFFILIATES_REWARDS: API + "/admin/add-affiliates-reward",
    CANCEL_GIFT_CARD: API + "/admin/cancel-gift-card",  
    REMOVE_USER_FROM_SUPPRESSION_LIST: API + "/admin/remove-user-from-suppression-list",
    REMOVE_PIN_FOR_USER: API + "/admin/remove-pin-for-user",
    FORCE_LOGOUT_USER: API + "/admin/force-logout-user",
    USER_MORTGAGE_DATA: API + "/admin/user-mortgage-data",
    RESET_CREDIT_REPORT_PULL_ATTEMPTS: API + "/admin/reset-credit-report-pull-attempts",
    CHANGE_GIFT_CARD_STATE: API + "/admin/change-giftcard-state",
    CREATE_PROMOCODE: API + "/admin/create-promocode",
    BULK_CREATE_PROMOCODE: API + "/admin/bulk-create-promocode",
    RESTORE_USER_ACCOUNT: API + "/admin/restore-user-account",
    TRUELAYER_SYNC_FAILURE_MONITOR: API + "/admin/truelayer-sync-account-failure-monitor",
    DUPE_ACCOUNT_CHECK: API + "/admin/dupe-account-check",
    DELETE_VRP_CONSENT: API + "/admin/delete-vrp-consent",
    SUPERCHARGED_CALCULATER: API + "/admin/calculate-supercharged-rate",
    GIFT_CARD_DETAILS_PAGE: API + "/admin/gift-card-details-page",
    VDX_DASHBOARD_DETAILS: API + "/admin/vdx-dashboard-details",
    USER_PARTNERIZE_ACTIVITY: API + "/admin/user-partnerize-activity",
    USER_AWIN_ACTIVITY: API + "/admin/user-awin-activity",
    USER_AFFILIATE_ACTIVITY: API + "/admin/user-affiliate-activity",
    FEATURE_FLAG_DASHBOARD: API + "/admin/feature-flag-dashboard",
    UPDATE_USER: API + "/admin/update-user",
    MOVE_ACCOUNT_REWARDS: API + "/admin/rewards/move-to-another-account",
    REMOVE_BIOMETRIC_FOR_USER: API + "/admin/remove-biometric-for-user",
    MANAGE_USER_PASSKEYS: API + "/admin/manage-user-passkeys",
    MANAGE_DEVICE_SIGNATURES: API + "/admin/manage-device-signatures",
    MASTER_TO_USER_EWALLET_DASHBOARD: API + "/admin/master-to-user-ewallet-dashboard",
    TRANSFER_MASTER_TO_REWARDS: API + "/admin/transfer-master-wallet-amount-to-rewards-wallet",
    TRANSFER_REWARDS_TO_MASTER: API + "/admin/transfer-rewards-wallet-amount-to-master-wallet",
    UPDATE_MASTER_TO_USER_EWALLET_FAILURE: API + "/admin/master-to-user-ewallet-dashboard",
    CHECK_MASTER_BALANCE: API + "/admin/master-to-user-ewallet-dashboard",
    NATWEST_TRANSFER: API + "/admin/natwest-transfer",
    GIFT_CARD_REFUND_ARCHIVE: API + "/admin/gift-card-refund-archive",
    TRANSACTION_PROVIDER_STATUS: API + "/admin/transaction-provider-status",
    VDX_BRANDS: API + "/admin/vdx-brands",
    PARTNERIZE_BRANDS: API + "/admin/partnerize-brands",
    AWIN_BRANDS: API + "/admin/awin-brands",
    CLO_RETAILERS: API + "/admin/clo-retailers",
    CLO_MIDS: API + "/admin/clo-mids",
    CLO_MIDS_IMPORT: API + "/admin/clo-mids-import",
    CLO_UNKNOWN_MIDS: API + "/admin/clo-unknown-mids",
    CLO_CAMPAIGNS: API + "/admin/clo-campaigns",
    CLO_CAMPAIGN_ACTIONS: API + "/admin/clo-campaign-actions",
    CLO_AUDIT: API + "/admin/clo-audit",
    CLO_MERCHANTS: API + "/admin/clo-merchants",
    CLO_MERCHANT_ACTIONS: API + "/admin/clo-merchant-actions",
    CLO_MERCHANT_CANDIDATES: API + "/admin/clo-merchant-candidates",
    CLO_MERCHANT_PATTERNS: API + "/admin/clo-merchant-patterns",
    CLO_MERCHANT_GROUPS: API + "/admin/clo-merchant-groups",
    CLO_UNMATCHED_DESCRIPTORS: API + "/admin/clo-unmatched-descriptors",
    CLO_COHORT_DEFINITIONS: API + "/admin/clo-cohort-definitions",
    CLO_COHORT_ACTIONS: API + "/admin/clo-cohort-actions",
    CLO_COHORT_MEMBERS: API + "/admin/clo-cohort-members",
    CLO_COHORT_STATS: API + "/admin/clo-cohort-stats",
    VDX_BRAND_URL_TEST: API + "/admin/vdx-brand-url-test",
    VDX_CHECK: API + "/admin/vdx/check",
    VDX_CLAIM_SUBMIT: API + "/admin/vdx-claim-submit",
    VDX_BRAND_BLACKLIST: API + "/admin/vdx-brand-blacklist",
    AFFILIATE_PASSWORD_RESET: API + "/admin/affiliate-password-reset",
    GIFT_CARD_CANCELLATION_HISTORY: API + "/admin/gift-card-cancellation-history",
    GIFT_CARD_LOSS_ABSORBED: API + "/admin/gift-card-loss-absorbed",
    GIFT_CARD_BRAND_MANAGEMENT: API + "/admin/gift-card-brand-management",
    PPS_MONEY_MANAGEMENT: API + "/admin/pps-money-management",
    PPS_MASTER_ACCOUNTS: API + "/admin/pps-master-accounts",
    PPS_MASTER_ACCOUNT_RETURNS: API + "/admin/pps-master-account-returns",
    REWARDS_EWALLET_HISTORY_FETCH: API + "/admin/rewards-ewallet-history-fetch",
    CONSTANTS_KEY_VALUE_DASHBOARD: API + "/admin/constants-key-value-dashboard",
    FRAUD_REVIEW: API + "/admin/fraud-review",
    FRAUD_BLOCKED_INSTRUMENT: API + "/admin/fraud-blocked-instrument",
    // Source-agnostic Didit view (mortgage KYC + fraud identity verification).
    DIDIT: API + "/admin/didit",
    ADMIN_GIFT_CARD_BALANCE_CHECK: API + "/admin/gift-card-balance-check",
    UPDATE_PAYMENT_REFERENCE: API + "/admin/update-payment-reference",
    CREATE_CREDIT_REPORT_MORTGAGE: API + "/admin/create-credit-report-mortgage",
    MANAGE_LINKED_ACCOUNT: API + "/admin/manage-linked-account",
    ADMIN_AUTO_SAVES: API + "/admin/auto-saves",
    ADMIN_AUTO_SAVE_DEBITS: API + "/admin/auto-saves/debits",
    MORTGAGE_KYC_OVERVIEW: API + "/admin/mortgage-kyc/overview",
    MORTGAGE_KYC_EVENTS: API + "/admin/mortgage-kyc/events",
    MORTGAGE_KYC_DIDIT: API + "/admin/mortgage-kyc/didit",
    MORTGAGE_KYC_CLAIMS: API + "/admin/mortgage-kyc/claims",
    MORTGAGE_KYC_REVIEWS: API + "/admin/mortgage-kyc/reviews",
    MORTGAGE_KYC_CHANGES: API + "/admin/mortgage-kyc/changes",
    MORTGAGE_KYC_DOCUMENT: API + "/admin/mortgage-kyc/document",
    MORTGAGE_KYC_STATUS: API + "/admin/mortgage-kyc/status",
    ADMIN_BPS_PAYER: API + "/admin/bps-payer",
    MC_ANYWHERE_ADMIN: API + "/admin/mastercard-anywhere-admin",
    MC_ANYWHERE_ACCESS: API + "/admin/mastercard-anywhere-access",
    LOAD_MONEY_PPS_SANDBOX_ACCOUNT: API + "/admin/load-money-pps-sandbox-account",
    ADMIN_SMART_TOPUPS: API + "/admin/smart-topups",
    ADMIN_SMART_TOPUPS_AUDITS: API + "/admin/smart-topups/audits",
    ADMIN_GIFT_CARDS_TOPUP_TRANSACTIONS: API + "/admin/gift-cards/topup-transactions",
    EWALLET_REGISTRATION: API + "/admin/ewallet-registration",
    UPDATE_GIFT_CARD_PAYMENT: API + "/admin/update-gift-card-payment",
    // Brand catalog admin (unified endpoint)
    BRAND_CATALOG: API + "/admin/brand-catalog",
    PAYMENT_PROVIDER_BANKS: API + "/admin/payment-provider-banks",
    CLO_BILLING_ACCOUNTS: API + "/admin/clo-billing-accounts",
    CLO_INVOICES: API + "/admin/clo-invoices",
    CLO_PAYMENTS: API + "/admin/clo-payments",
    CLO_TRANSACTIONS: API + "/admin/clo-transactions",
    CLO_RECONCILIATION: API + "/admin/clo-reconciliation",
    CLO_ARREARS: API + "/admin/clo-arrears",
    CLO_BILLING_REPORTS: API + "/admin/clo-billing-reports",
    CLO_WALLETS: API + "/admin/clo-wallets",
    CLO_WALLET_ADJUSTMENTS: API + "/admin/clo-wallet-adjustments",
    CLO_BREAKAGE: API + "/admin/clo-breakage",
}

export default ENDPOINTS;
